import { styled } from '@mui/material/styles';

import boardIcon from '@/assets/images/landingPages/marchCampaign/image_board.svg';
import mountainIcon from '@/assets/images/landingPages/marchCampaign/image_mountain.svg';
import skisIcon from '@/assets/images/landingPages/marchCampaign/image_ski.svg';
import type { CompetitionWinner } from '@/lib/api/requests.ts';

import CircleWithNumber from './_components/CircleWithNumber/index.ts';
import CTAComponent from './_components/CTAComponent/index.ts';
import data from './data.json';

const BoxContainerWrapper = styled('div')(({ theme }) => ({
  position: 'relative',
  width: '40%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  background: theme.palette.common.white,
  borderRadius: '12px',
  marginTop: theme.spacing(12),
  paddingTop: theme.spacing(7.5),
  [theme.breakpoints.down('xl')]: {
    width: '55%',
  },
  [theme.breakpoints.down('lg')]: {
    width: '60%',
  },
  [theme.breakpoints.down('md')]: {
    width: '80%',
  },
  [theme.breakpoints.down('sm')]: {
    marginTop: theme.spacing(13),
    width: '90%',
    paddingTop: theme.spacing(2.5),
  },
}));

const ItemsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  flexDirection: 'column',
  color: 'white',
  padding: theme.spacing(5),
  width: '80%',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
  [theme.breakpoints.down('xs')]: {
    padding: theme.spacing(3),
  },
  marginTop: theme.spacing(-1),
}));

const Item = styled('li')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: theme.spacing(3),
  [theme.breakpoints.down('sm')]: {
    marginBottom: theme.spacing(1),
  },
}));

const CircleWithNumberWrapper = styled('div')({
  width: 28,
  height: 28,
});

const RulesText = styled('div')(({ theme }) => ({
  paddingLeft: theme.spacing(1),
  fontSize: '1.188rem',
  [theme.breakpoints.down('md')]: {
    fontSize: '1rem',
  },
}));

const RulesTextColor = styled('span')(({ theme }) => ({
  color: theme.palette.common.black,
}));

const MountainContainer = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: '-100px',
  left: '23%',
  transform: 'translateX(-50%)',
  [theme.breakpoints.down('sm')]: {
    left: '38%',
  },
}));

const SkisContainer = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: '-110px',
  left: '85%',
  transform: 'translateX(-50%)',
  [theme.breakpoints.down('sm')]: {
    left: '85%',
    top: '-80px',
  },
}));

const SkiIcon = styled('img')(({ theme }) => ({
  width: '140px',
  height: '200px',
  [theme.breakpoints.down('sm')]: {
    width: '80px',
    height: '120px',
  },
}));

const BoardContainer = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: '-100px',
  left: '50%',
  transform: 'translateX(-50%)',
  [theme.breakpoints.down('sm')]: {
    left: '47%',
  },
}));

const BoardIcon = styled('img')(({ theme }) => ({
  width: '500px',
  height: '200px',
  [theme.breakpoints.down('sm')]: {
    width: '300px',
    height: '150px',
  },
}));

const BoxContainer = (props: { winner: CompetitionWinner | undefined }) => {
  return (
    <BoxContainerWrapper>
      <MountainContainer>
        <img src={mountainIcon} alt="Mountain" />
      </MountainContainer>
      <SkisContainer>
        <SkiIcon src={skisIcon} alt="Skis" />
      </SkisContainer>
      <BoardContainer>
        <BoardIcon src={boardIcon} alt="Board" />
      </BoardContainer>

      <CTAComponent winner={props.winner} />

      <ItemsContainer>
        {data.rules.map((text) => (
          <Item key={text.index}>
            <CircleWithNumberWrapper>
              <CircleWithNumber number={text.index} />
            </CircleWithNumberWrapper>
            <RulesText className="typography-v1-legacy-p1">
              <RulesTextColor>
                <div dangerouslySetInnerHTML={{ __html: text.text }} />
              </RulesTextColor>
            </RulesText>
          </Item>
        ))}
      </ItemsContainer>
    </BoxContainerWrapper>
  );
};

export default BoxContainer;
